<template>
    <div @click="click($event)" :class="['auto-complete',{'focus': focus}]">
        <input class="present-input"
               type="text"
               :placeholder="placeholder"
               :disabled="disabledData"
               @focus="focus = true"
               v-model="inputValue" />

        <div v-show="focus" class="bg-effect" @click="hide()"></div>

        <div v-show="focus && (!showSecondList || !showCities)" ref="firstList" class="input-list">
            <div class="focus-input-wrap">
                <div v-for="(item, key) in selectedItems"
                     :key="key"
                     class="selected-items">
                    <span>{{item.text}}</span>
                    <svg @click="removeItem(key)" class="close-icon">
                        <use xlink:href="../../assets/images/sprite.svg#close"></use>
                    </svg>
                </div>
                <input class="focus-input"
                       type="text"
                       ref="autoComplateInput"
                       :placeholder="placeholder"
                       @input="searchItem()"
                       v-model="focusInputValue" />
            </div>
            <div class="shadow-inset"></div>
            <template>
                <p class="list-title">{{localizeList.allOptions}}</p>
                <div v-for="(item) in searchItems"
                     :key="item.id"
                     class="list-item">
                    <p @click="checked(item, true)" class="list-item-text">{{item.text}}</p>
                </div>
            </template>
        </div>

        <div class="input-list" ref="secondList" v-show="focus && showSecondList && showCities">
            <div class="focus-input-wrap">
                <div v-for="(item, key) in selectedItems"
                     :key="key"
                     :class="['selected-items',{'green': key === 0}]">
                    <span>{{item.text}}</span>
                    <svg @click="removeItem(key)" class="close-icon">
                        <use xlink:href="../../assets/images/sprite.svg#close"></use>
                    </svg>
                </div>
                <input class="focus-input"
                       type="text"
                       ref="secondAutoComplateInput"
                       :placeholder="placeholder"
                       @input="searchSecondItem()"
                       v-model="focusInputSecondValue" />
            </div>
            <template>
                <div class="shadow-inset"></div>
                <div v-for="(item, key) in searchSecondItems"
                     :key="key"
                     class="list-item">
                    <p @click="checked(item)" class="list-item-text">{{item.text}}</p>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    export default {
        name: "filter-to",
        data() {
            return {
                inputValue: "",
                focusInputValue: "",
                focusInputSecondValue: "",
                focus: false,
                disabledData: false,
                showSecondList: false,
                searchItems: [],
                searchSecondItems: [],
                selectedItems: [],
                citiesToStatus: true,
                chooseInfo: ""
            }
        },
        props: {
            secondItems: {
                type: Array,
                default: () => []
            },
            placeholder: {
                type: String,
                default: "text"
            },
            value: {
                type: [String, Number, Array],
                default: ""
            },
            showCities: {
                type: Boolean,
                default: true
            },
            items: {
                type: Object,
                default: null
            },
            disabled: {
                type: Boolean,
                default: false
            },
            focusFromParent: {
                type: Boolean,
                default: false
            },

        },
        mounted() {
            window.addEventListener('keydown', this.keyDown);

            this.disabledData = this.disabled;
            if (this.items) {
                this.searchItems = [...this.items.items]
            }
        },
        methods: {
            keyDown(e) {
                if (e.keyCode === 9) {
                    this.hide()
                }
            },
            checked(item, firstList = false) {
                if (firstList) {
                    if (this.selectedItems[0] && this.selectedItems[0].id === item.id) {
                        return
                    }
                    this.$emit("get-cities", item.id)
                }
                if (this.showCities) {
                    if (this.selectedItems.length < 2 && item)
                        this.selectedItems.push(item);

                    if (this.selectedItems.length === 2){
                        this.selectedItems = this.selectedItems.map((x, i) => {
                            if (i === 1){
                                return item
                            }

                            return x
                        });
                    }

                    if (this.selectedItems.length === 2){
                        if (this.focus) {
                            this.$emit("change", this.selectedItems)
                        }
                        this.hide();
                    }
                } else {
                    if (this.selectedItems.length < 1)
                        this.selectedItems.push(item);
                    if (this.selectedItems.length === 1)
                        this.selectedItems = [item];

                    if (this.focus) {
                        this.$emit("change", this.selectedItems)
                    }
                    this.hide();
                }
            },
            click(e) {
                this.$emit("click", e);
                if (!this.disabledData) {
                    this.$refs.autoComplateInput.focus()
                }
            },
            searchItem() {
                let searchText = this.focusInputValue;

                if (this.items) {
                    this.searchItems = this.items.items
                        .filter(x => x.text.toLowerCase().includes(searchText.toLowerCase()))
                        .map(x => {
                            this.selectedItems.forEach(x2 => {
                                if (x.id === x2.id) {
                                    x.isChecked = x2.isChecked
                                }
                            })
                            return x
                        })
                }
            },
            searchSecondItem() {
                let searchText = this.focusInputSecondValue;

                this.searchSecondItems = this.secondItems.filter(x => x.text.toLowerCase().includes(searchText.toLowerCase()))
                    .map(x => {
                        this.selectedItems.forEach(x2 => {
                            if (x.id === x2.id) {
                                x.isChecked = x2.isChecked
                            }
                        });
                        return x
                    })
            },
            removeItem(key) {
                if (key === 0){
                    this.selectedItems = []
                } else {
                    this.selectedItems.pop();
                }
                this.$emit("change", this.selectedItems);
                this.$emit("input", this.selectedItems.map(x => x.id))
            },
            hide() {
                this.focus = false;
            }
        },
        updated() {
            if (this.focus) {
                this.click(true)
            }
        },
        beforeDestroy() {
            window.removeEventListener('keydown', this.keyDown);
        },
        watch: {
            focusFromParent(val) {
                if (val) {
                    this.focus = true
                }
            },
            localizeList: {
                deep: true,
                handler(val) {
                    if (val.youCanSelectOnlyItem) {
                        this.chooseInfo = val.youCanSelectOnlyItem
                    }
                }
            },
            disabled(val) {
                this.disabledData = val
            },
            value(val, oldVal) {
                let isRepeat = true;
                if (val) {
                    val.forEach(x => {
                        if (!oldVal.includes(x)) {
                            isRepeat = false
                        }
                    })
                }
                if (isRepeat) return;

                if (!val.length) {
                    this.selectedItems = [];
                    return;
                }
                let item = this.items.items.find(x => x.id === val[0]);
                this.checked(item, true);

                if (val[1]) {
                    let item = this.secondItems.find(x => x.id === val[1]);
                    this.checked(item);
                }
            },
            'items.items': {
                deep: true,
                handler(val) {
                    let isSelected = !this.searchItems.length;
                    let set = new Set(val);
                    this.searchItems = Array.from(set).map(x => {
                        if (this.selectedItems.map(x2 => x2.id).includes(x.id)) {
                            x.isChecked = true;
                            isSelected = true;
                        }
                        return x
                    });
                    if (!isSelected) this.removeItem(0);
                }
            },
            secondItems: {
                deep: true,
                handler(val) {
                    if(this.value[1]) {
                        let item = val.find(x => x.id === this.value[1]);
                        if (item)
                            this.checked(item);
                        else
                            this.selectedItems = this.selectedItems.filter((x,i) => i === 0)
                    }
                    this.searchSecondItems = [...val]
                }
            },
            focus(val) {
                if (val) {
                    this.$emit("focus", true)
                } else {
                    this.$emit("blur", true)
                }
            },
            selectedItems(val) {
                this.showSecondList = val.length > 0;

                if (val.length === 1){
                    this.inputValue = val[0].text;
                } else if (val.length === 2) {
                    this.inputValue = `${val[0].text} – ${val[1].text}`;
                } else {
                    this.inputValue = ""
                }

                let ids = [];
                if (val.length)
                    ids = val.map(x => x.id);
                this.$emit("input", ids)
            },
        }
    }
</script>

<style scoped>
    .auto-complete {
        position: relative;
    }
    .auto-complete input {
        width: 100%;
        border: none;
        outline: none;
        padding: 8px 40px 8px 12px;
        background-color: var(--lighten-6-color);
        border-radius: 3px;
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
        color: #333;
    }
    .auto-complete input::placeholder {
        color: var(--lighten-5-color);
    }
    .bg-effect{
        z-index: 100;
    }
    .input-list {
        overflow: auto;
        max-height: 90vh;
        min-width: calc(100% + 20px);
        max-width: 300px;
        position: absolute;
        top: -12px;
        left: -12px;
        z-index: 100;
        background-color: var(--white-color);
        box-shadow: 0 5px 15px rgba(0, 0, 0, .5);
        border-radius: 4px;
    }
    .input-list .focus-input-wrap{
        margin: 12px;
        border: 2px solid var(--primary-color);
        border-radius: 3px;
        padding: 6px 6px 0 6px;
        display: flex;
        flex-wrap: wrap;
    }
    .input-list .focus-input-wrap .selected-items {
        background: var(--primary-color);
        border-radius: 3px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 6px;
        height: 32px;
        margin: 0 4px 4px 0;
    }
    .input-list .focus-input-wrap .selected-items.green {
        background: var(--green-color);
    }
    .input-list .focus-input-wrap .selected-items span {
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        color: var(--white-color);
    }
    .input-list .focus-input-wrap .selected-items .close-icon {
        width: 9px;
        height: 9px;
        fill: var(--white-color);
        opacity:.7;
        margin-left: 3px;
        cursor:pointer;
    }
    .input-list .focus-input-wrap .selected-items .close-icon:hover {
        opacity: 1;
    }
    .input-list .focus-input-wrap input {
        background-color: transparent;
        padding: 3px 2px;
        width: 100px;
        margin-bottom: 4px;
    }
    .input-list .list-item  {
        padding: 10px 12px;
        transition: all .2s;
        cursor: pointer;
    }
    .input-list .list-item:hover,
    .input-list .list-item.hover {
        background-color: var(--lighten-1-color);
    }
    .input-list .list-item .list-item-text {
        font-weight: 500;
        font-size: 16px;
        color: var(--dark-1-color);
        padding-left: 12px;
        margin: 0;
    }
    .input-list .shadow-inset {
        width: 100%;
        height: 2px;
        box-shadow: 0 3px 5px rgba(100,100,100,.1);
    }
    .input-list .list-title {
        font-weight: normal;
        font-size: 15px;
        line-height: 30px;
        color: var(--lighten-5-color);
        border-bottom: 1px solid var(--lighten-4-color);
        padding: 10px;
        margin: 0;
    }
</style>
